module.exports = __webpack_public_path__ + "static/media/lmheavy.0ef6c200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/experiences/lmheavy.jpg
// module id = 102
// module chunks = 0